import { Injectable } from '@angular/core';
import { ApiEndpoint } from './endpoint.interface';
import { ApiNavigation } from './navigation.interface';
import { APISpec } from './api-spec.interface';
import { resolveSpecRefs, validateSpec } from './spec-ref-resolver';
import { parseEndpoints } from './endpoint-parser.utils';
import { buildNavigation } from './navigation-builder.utils';

/**
 * Browser-safe OpenAPI 3.0 parser: validates the spec, resolves references
 * and produces the endpoint list plus the docs navigation tree.
 */
@Injectable({
  providedIn: 'root',
})
export class APIParserService {
  /**
   * Parse an OpenAPI specification into endpoints and navigation structure
   * @param spec - The OpenAPI specification to parse
   * @returns Object containing parsed endpoints and navigation structure
   */
  async parseSpec(spec: APISpec): Promise<{ endpoints: ApiEndpoint[]; navigation: ApiNavigation }> {
    try {
      validateSpec(spec);

      const resolvedSpec = resolveSpecRefs(spec);
      const endpoints = parseEndpoints(resolvedSpec);
      const navigation = buildNavigation(resolvedSpec, endpoints);

      return { endpoints, navigation };
    } catch (error) {
      console.error('Error parsing OpenAPI specification:', error);
      throw error;
    }
  }
}
